import { dispatchOther } from '../../redux/redux.utils';
import axios from '../../services/axios';
import type { DeleteResponseStatusFragment } from '../../thread/api/message';
import { updateMessage } from '../../thread/ThreadMessage/thread-slice';

interface AdminDeleteCommentResponseData extends DeleteResponseStatusFragment {
  // cached_author: {
  //   username: 'graphcomment';
  //   email: 'mathias+recette@semiologic.fr';
  //   picture: '/images/avatar_3.png';
  //   user_rank: 80925.2054;
  // };
  // moderation: {
  //   result: {
  //     created_at: '2023-08-04T08:22:15.028Z';
  //     provider: 'admin';
  //     status: 'NOK';
  //     updated_at: '2023-08-04T08:22:54.632Z';
  //     motif: 'Pour tester';
  //     motif_id: 99;
  //   };
  //   sended: 'off';
  // };
  // export: {
  //   owner: {
  //     exported: false;
  //   };
  // };
  // inbox: false;
  // user_visibility: [];
  // quotes: [];
  // files: [];
  // offenses: [];
  // alerts: [];
  // tags: [];
  // hidden_embeds: [];
  // expressions: [];
  // expressions_comparaison_count: 0;
  // expressions_length: 0;
  // smart_auto: 'off';
  // suggest_ai: 'off';
  // auto_expression: false;
  // guest: false;
  // child_comments: [];
  status: string; // e.g. 'deleted'
  // score_received: '3';
  // score_gived: '3';
  // moderation_percentage_negative: 86.66666666666667;
  // boost: 0;
  // score: 0;
  // result: -367;
  // score_histo: -370;
  // views: 0;
  // spam: false;
  // shadow: false;
  // is_edited: false;
  _id: string;
  // content: '<p>Comme tu dis 3</p>';
  // embeds: '{"time":1691137333199,"blocks":[{"id":"4IvX9H1k-0","type":"paragraph","data":{"text":"Comme tu dis 3"},"tunes":{"alignAll":{"alignment":"left"}}}],"version":"2"}';
  // parent_id: '64c612a3e02ec021c11f9bbf';
  // root_id: '64c0ec528c796d215dc9243f';
  // website: '5d88da3d3f5f632e2297f4dc';
  // thread: {
  //   exports: {
  //     moderation: {
  //       sended: 'off';
  //     };
  //   };
  //   count_comments: 24;
  //   inbox: false;
  //   user_visibility: [];
  //   surveys: [];
  //   child_comments: [
  //     '64a513886f997c7f1fdaba5e',
  //     '64b16c4aba1c09193cf053cd',
  //     '64c0ec528c796d215dc9243f',
  //     '64c4dd496d871321c0d3beaf',
  //   ];
  //   moderation: 100;
  //   is_locked: false;
  //   is_closed: false;
  //   algo_save: false;
  //   _id: '64a2907f1a8d22cc888cb9ec';
  //   full_id: 'MyApp@MyApp@64a2907e003a0c6cf83d803b|debate.graphcomment.com/t/je-pense-que-c-est-le-titre';
  //   website: '5d88da3d3f5f632e2297f4dc';
  //   __v: 0;
  //   created_at: '2023-07-03T09:10:23.223Z';
  //   daily_views: [];
  //   ecd: [];
  //   identifier: 'debate.graphcomment.com/t/je-pense-que-c-est-le-titre';
  //   page: '64a2907e003a0c6cf83d803b';
  //   page_title: "Je pense que c'est le titre";
  //   uid: 'MyApp@64a2907e003a0c6cf83d803b';
  //   updated_at: '2023-07-03T09:10:23.223Z';
  //   url: 'https://debate.graphcomment.com/t/je-pense-que-c-est-le-titre';
  //   refresh_cache: '2023-08-02T12:00:00.700Z';
  //   last_comment: '64ccb53770e7a021cd16b0c3';
  //   last_comment_date: '2023-08-04T08:22:15.005Z';
  // };
  // page: '64a2907e003a0c6cf83d803b';
  // author: '56543ef6d4ce5c20546852be';
  // ip: '160.202.160.248:34916';
  // external_quotes: [];
  // voters: [];
  // edited_at: '2023-08-04T08:22:54.634Z';
  // updated_at: '2023-08-04T08:22:15.737Z';
  // created_at: '2023-08-04T08:22:15.005Z';
  // __v: 0;
}

export const adminDeleteComment = async ({
  commentId,
  motifId,
  motif,
  threadId,
  websiteId,
  preserveDiscussion,
}: {
  commentId: string | number;
  motifId: string | number;
  threadId: string | number;
  websiteId: string | number;
  motif?: string;
  preserveDiscussion: boolean;
}) => {
  const { data } = await axios.post<AdminDeleteCommentResponseData>(
    `/api/website/${websiteId}/thread/${threadId}/comment/${commentId}/${
      preserveDiscussion ? 'disapprove' : 'deleted'
    }/`,
    {
      motif_id: motifId,
      motif,
    },
  );
  const { _id, status } = data;
  dispatchOther(
    updateMessage({
      message: { id: _id, status },
      noErrorIfMissing: true,
      deleteChildren: !preserveDiscussion,
    }),
  );
  return data;
};

export const adminDeleteTopic = ({
  motifId,
  motif,
  pageId,
}: {
  motifId: string | number;
  pageId: string | number;
  motif?: string;
}) =>
  axios.put(`/api/page/${pageId}/status`, {
    status: 'deleted',
    motif_id: motifId,
    motif,
  });
